import { Button } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

import { RouteNameEnum, useRoutes } from '../../../navigation';
import { canSendEnrollmentInvitation, hasEnrollmentInvitation } from '../../studentsUtils';

type SendEnrollmentInvitationButtonProps = {
  student: any;
  canEdit: boolean;
};

/**
 * Entry point to the enrollment wizard from the student profile (CCMS-8123).
 *
 * The wizard is the only way to send a family their enrollment packet, and
 * before this button the only route to it after student creation was a link
 * inside the Enrollment edit dialog, which providers did not find. Renders
 * nothing when the student could not need a packet; see
 * `canSendEnrollmentInvitation` for why `pending` alone is not the gate.
 */
export function SendEnrollmentInvitationButton({ student, canEdit }: SendEnrollmentInvitationButtonProps) {
  const { t } = useTranslation();
  const { gotoRouteByName } = useRoutes();

  if (!canEdit || !canSendEnrollmentInvitation(student)) return null;

  const label = hasEnrollmentInvitation(student)
    ? t('enrollments.resendEnrollmentInvitation')
    : t('enrollments.sendEnrollmentInvitation');

  return (
    <Button
      primary
      onClick={(e) => {
        e.preventDefault();
        gotoRouteByName(RouteNameEnum.STUDENT_ENROLLMENT, [{ name: 'studentId', value: student.id }]);
      }}
      label={label}
      data-testid="send-enrollment-invitation-btn"
    />
  );
}
